import { Video } from '../types';
import { VideoCard } from './VideoCard';

interface VideoGridProps {
  videos: Video[];
  onPlayVideo?: (video: Video) => void;
  onAddToWatchLater?: (video: Video) => void;
  watchLaterIds?: string[];
  selectedIndex?: number;
  onChannelClick?: (channelId: string) => void;
  compareIds?: string[];
  onCompareToggle?: (video: Video) => void;
}

/**
 * Grid component that displays a list of video cards
 */
export function VideoGrid({
  videos,
  onPlayVideo,
  onAddToWatchLater,
  watchLaterIds = [],
  selectedIndex = -1,
  onChannelClick,
  compareIds = [],
  onCompareToggle,
}: VideoGridProps) {
  if (videos.length === 0) {
    return (
      <div className="video-grid-empty">
        <p>No videos found for this category.</p>
      </div>
    );
  }

  return (
    <div className="video-grid">
      {videos.map((video, index) => (
        <VideoCard
          key={video.id}
          video={video}
          rank={index + 1}
          onPlay={onPlayVideo}
          onAddToWatchLater={onAddToWatchLater}
          isInWatchLater={watchLaterIds.includes(video.id)}
          isSelected={index === selectedIndex}
          onChannelClick={onChannelClick}
          isCompareSelected={compareIds.includes(video.id)}
          onCompareToggle={onCompareToggle}
        />
      ))}
    </div>
  );
}
